import { z } from 'zod';
import {
  emailSchema,
  isoDateSchema,
  isoDateTimeSchema,
  phoneSchema,
  timestampedSchema,
  uuidSchema,
} from './common';

export const leadStatusSchema = z.enum([
  'inquiry',
  'trial_booked',
  'trial_attended',
  'consult_needed',
  'waiver_pending',
  'payment_pending',
  'enrolled',
  'lost',
]);
export type LeadStatus = z.infer<typeof leadStatusSchema>;

export const trialStatusSchema = z.enum(['booked', 'attended', 'missed', 'cancelled', 'converted']);
export type TrialStatus = z.infer<typeof trialStatusSchema>;

export const studioLeadInputSchema = z.object({
  converted_family_id: uuidSchema.optional(),
  guardian_name: z.string().trim().min(1).max(200),
  guardian_email: emailSchema,
  guardian_phone: phoneSchema.optional(),
  dancer_name: z.string().trim().min(1).max(160),
  dancer_birthdate: isoDateSchema.optional(),
  lead_status: leadStatusSchema.default('inquiry'),
  source: z.string().trim().min(1).max(120).optional(),
  desired_program_id: uuidSchema.optional(),
  notes: z.string().trim().max(5000).optional(),
  lost_reason: z.string().trim().max(1000).optional(),
});
export type StudioLeadInput = z.input<typeof studioLeadInputSchema>;

export const studioLeadSchema = timestampedSchema.and(
  z.object({
    converted_family_id: uuidSchema.nullable(),
    guardian_name: z.string(),
    guardian_email: z.string(),
    guardian_phone: z.string().nullable(),
    dancer_name: z.string(),
    dancer_birthdate: isoDateSchema.nullable(),
    lead_status: leadStatusSchema,
    source: z.string().nullable(),
    desired_program_id: uuidSchema.nullable(),
    notes: z.string().nullable(),
    lost_reason: z.string().nullable(),
  }),
);
export type StudioLead = z.infer<typeof studioLeadSchema>;

export const trialBookingInputSchema = z.object({
  lead_id: uuidSchema,
  class_id: uuidSchema.optional(),
  program_id: uuidSchema.optional(),
  trial_date: isoDateSchema,
  status: trialStatusSchema.default('booked'),
  attended_at: isoDateTimeSchema.optional(),
  notes: z.string().trim().max(3000).optional(),
});
export type TrialBookingInput = z.input<typeof trialBookingInputSchema>;

export const trialBookingSchema = timestampedSchema.and(
  z.object({
    lead_id: uuidSchema,
    class_id: uuidSchema.nullable(),
    program_id: uuidSchema.nullable(),
    trial_date: isoDateSchema,
    status: trialStatusSchema,
    attended_at: isoDateTimeSchema.nullable(),
    notes: z.string().nullable(),
  }),
);
export type TrialBooking = z.infer<typeof trialBookingSchema>;
